import _JSON$stringify from "@babel/runtime-corejs2/core-js/json/stringify";
import { isExternal } from '@/utils/validate';
export default {
  props: {
    to: {
      type: String,
      required: true
    },
    url: {
      type: String,
      default: ''
    },
    item: {
      type: Object,
      default: () => {}
    },
    parent: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    isExternal,
    clickRouter() {
      let url;
      if (this.url.substr(0, 6) === 'PAY://') {
        url = process.env.VUE_APP_BMMS_URL + this.url.substring(6);
      } else {
        url = process.env.VUE_APP_PDS_URL + this.url;
      }
      this.$router.push({
        path: `/iframe/go`,
        query: {
          route: `${_JSON$stringify(this.item)}`,
          parent: _JSON$stringify(this.parent),
          url
        }
      });
    },
    linkProps(url) {
      if (isExternal(url)) {
        return {
          is: 'a',
          href: url,
          target: '_blank',
          rel: 'noopener',
          class: 'menu-link-wrap'
        };
      }
      return {
        is: 'router-link',
        to: url,
        class: 'menu-link-wrap'
      };
    }
  }
};